const getters = {
  all: state => state.all,
  allInGroups: state => state.allInGroups || [],
  byAccountNumber: state => accountNumber => state.all.find(a => a.account_number === accountNumber),
  selected: state => state.selected,
  selectedBuildingsId: state => state.selected.address[0].id,
  selectedMCS: state => state.selected.address[0].management_companies_id,
  selectedType: state => state.types.find(t => t.id === state.selected.type_apart) || state.defaultType,
  selectedPublicId: (state, getters) => getters.selected.address[0].publicid,
  canPay: (state, getters) => !!getters.selectedPublicId,
  typeById: state => id => state.types.find(t => t.id === id) || state.defaultType,
  selectedOwners: state => state.owners,
  leInfo: state => state.leInfo
};

export default getters;
